import styled from 'styled-components';

import { styledLayout } from '@pkg/primitives';

import { tokens } from '../../tokens';

export const LayoutWrapper = styled.div`
    ${styledLayout.fullHeightFix};
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacing.tight}px;
    flex: 1 1 auto;
`;
